import { render, staticRenderFns } from "./EmployeeCard.vue?vue&type=template&id=dfde82fc&scoped=true"
import script from "./EmployeeCard.vue?vue&type=script&lang=js"
export * from "./EmployeeCard.vue?vue&type=script&lang=js"
import style0 from "./EmployeeCard.vue?vue&type=style&index=0&id=dfde82fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfde82fc",
  null
  
)

export default component.exports